import {FormatInterface} from './FormatInterface';
import {FormatPayload} from './FormatPayload';

export class Format {
	public static copy(format: FormatInterface):FormatInterface {
		return {
			numbers: {...format.numbers},
			currency: {...format.currency},
			unit: {...format.unit},
			dates: {...format.dates}
		};
	}

	public static fromLocale(locale: string = 'en_IN', formats?: any):FormatInterface {
		let language = locale.split('_')[0];
		let country = locale.split('_')[1];

		let o = {};
		findSection(o, (formats || FormatPayload), language, country);

		return (o as FormatInterface);
	}
}

let findSection = (returnObject: any, payloadObject: any, language: string, country: string) => {
	for(let name in payloadObject) {
		if(name.length !== 2) {
			if(typeof(payloadObject[name]) === 'object') {
				returnObject[name] = {};
				findSection(returnObject[name], payloadObject[name], language, country);
			} else {
				returnObject[name] = payloadObject[name];
			}
		} else {
			if(name === language || name === country) {
				findSection(returnObject, payloadObject[name], language, country);
			}
		}
	}
};
